import axios from 'axios';

export const bulkUpdate = {
    namespaced: true,
    state: {
        options: {
            allowed_fields: {},
            last_rollback: null
        },
        loading: false
    },
    getters: {
        options: (state) => state?.options || {},
        allowedFields: (state) => state?.options?.allowed_fields || {},
        lastRollback: (state) => state?.options?.last_rollback || null,
        loading: (state) => state?.loading || false
    },
    actions: {
        getOptions: function (context) {
            return new Promise((resolve, reject) => {
                axios.get('/admin/bulk-update/options')
                    .then((res) => {
                        context.commit('setOptions', res.data.data);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        batchUpdate: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.post('/admin/bulk-update/batch', payload)
                    .then((res) => {
                        context.dispatch('getOptions');
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        quickUpdate: function (context, { productId, field, value }) {
            return new Promise((resolve, reject) => {
                axios.patch(`/admin/bulk-update/quick-update/${productId}`, { field, value })
                    .then((res) => {
                        context.dispatch('getOptions');
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        exportCustom: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.post('/admin/bulk-update/export-custom', payload, {
                    responseType: 'blob'
                })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        importCustom: function (context, formData) {
            return new Promise((resolve, reject) => {
                axios.post('/admin/bulk-update/import-custom', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                    .then((res) => {
                        context.dispatch('getOptions');
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        rollback: function (context, logId = null) {
            return new Promise((resolve, reject) => {
                axios.post('/admin/bulk-update/rollback', { log_id: logId })
                    .then((res) => {
                        context.dispatch('getOptions');
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    },
    mutations: {
        setOptions: function (state, payload) {
            state.options = payload || { allowed_fields: {}, last_rollback: null };
        },
        setLoading: function (state, payload) {
            state.loading = payload;
        }
    }
};
